<template>
  <div class="news-card">
    <!-- 头部：包含主标题和副标题 -->
    <div class="news-header">
      <h2 class="main-title">{{ title }}</h2>
      <span class="sub-title">{{ subtitle }}</span>
    </div>

    <!-- 主体：包含描述文本和图片 -->
    <div class="news-body">
      <div  class="description"><p>{{ description }}</p></div>

      <div class="image-grid">
        <img
            v-for="(imgSrc, index) in images"
            :key="index"
            :src="imgSrc"
            alt="新闻配图"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsItem',
  // 定义从父组件接收的属性 (props)
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
/* 卡片整体样式 */
.news-card {
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden; /* 确保圆角效果 */
  width: 80%;
  margin-left: 10%;
}

/* 头部样式 */
.news-header {
  padding: 20px 25px;
  border-bottom: 1px solid #eaeaea;
  background-image: url("../../assets/image/标题背景.png");
  background-size: 100% 100%;
  width: 400px;
  height: 50px;
  margin-top: 20px;
  margin-left: 20px;
}

.main-title {
  color: #d9534f; /* 红色标题 */
  font-size: 20px;
  margin: -10px 0 10px 0;
  font-weight: bold;
}

.sub-title {
  display: inline-block;
  /*background-color: #f0ad4e;  橙色背景 */
  color: #ffffff;
  padding: 5px 60px;
  border-radius: 4px;
  font-size: 20px;
  font-weight: bold;
}

/* 主体内容样式 */
.news-body {
  padding: 25px;
}

.description {
  color: #555;
  line-height: 1.8;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 25px;
  text-align: justify;
  background-image: url("../../assets/image/文字背景.jpg");
  background-size: 100% 100%;
  text-indent: 2em;
}

/* 图片网格布局 */
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.image-grid img {
  width: 100%;
  height: auto;
  border-radius: 6px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
</style>
